import { useToast } from "@mallardbay/lib-react-components"

import type { GuestUserInput } from "~graphql/generated/graphql"
import { useLogInAsGuestUserMutation } from "~graphql/generated/graphql"
import { accessTokenVar } from "~utils/auth-hooks"
import usePersistedGuestAccessToken from "~utils/use-persisted-guest-access-token"

export default function useLogInAsGuestUser({
    onSuccess,
}: {
    onSuccess?: () => void
}) {
    const { showError } = useToast()
    const { setGuestTokenInfo } = usePersistedGuestAccessToken()

    const [logInAsGuestUserMutation, { loading: isLoading, error }] =
        useLogInAsGuestUserMutation({
            onError: showError,
            onCompleted: (data) => {
                const accessToken = data.logInAsGuestUser
                const createdAt = Date.now()

                setGuestTokenInfo({ accessToken, createdAt })
                accessTokenVar(accessToken)
                onSuccess?.()
            },
        })

    const logInAsGuestUser = (data: GuestUserInput) =>
        logInAsGuestUserMutation({ variables: { data } })

    return { logInAsGuestUser, isLoading, error }
}
